import React, { createContext, useContext, useState, useCallback, useEffect, useRef } from 'react';
import { subdomainMonitorsAPI } from '../services/api';
import { useAuth } from './AuthContext';

const SubdomainMonitorBadgeContext = createContext(null);

export const SubdomainMonitorBadgeProvider = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const [totalNew, setTotalNew] = useState(0);
  const pollRef = useRef(null);

  const refresh = useCallback(async () => {
    if (!isAuthenticated) return;
    try {
      const data = await subdomainMonitorsAPI.list();
      setTotalNew(data.total_new_count || 0);
    } catch (_) {
      // non-critical
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (!isAuthenticated) {
      setTotalNew(0);
      return;
    }
    refresh();
    pollRef.current = setInterval(refresh, 30000);
    return () => clearInterval(pollRef.current);
  }, [isAuthenticated, refresh]);

  return (
    <SubdomainMonitorBadgeContext.Provider value={{ totalNew, refresh }}>
      {children}
    </SubdomainMonitorBadgeContext.Provider>
  );
};

export const useSubdomainMonitorBadge = () => {
  const ctx = useContext(SubdomainMonitorBadgeContext);
  if (!ctx) throw new Error('useSubdomainMonitorBadge must be used within SubdomainMonitorBadgeProvider');
  return ctx;
};
